import React from 'react';
import ReactDOM from 'react-dom';
import EMutabakatUygulama from './sayfalar';

ReactDOM.render(<EMutabakatUygulama />, document.getElementById('root'));